import i18n from "../infrastructure/I18n/i18n";

const getFormattedDate = (dateInput: $TSFixMe) => {
    const locale = i18n.language;
    if (!dateInput) return '';
    const date = new Date(dateInput);
    if (!date || !date.toLocaleDateString) return '';
    return `${date.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' })}, ${date.toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: 'numeric'
    })}`;
};

export default getFormattedDate;
